import { _createAnimatedElementAnimation } from "theme-ghd";

var ScrollTriggerGHD = class extends HTMLElement {
    constructor() {
		super();
	}

    connectedCallback() {
		if (!this.scrollTrigger) {
			throw "ERROR";
		}

		this.addEventListener("scroll:trigger:refresh", () => this._rebuild());
		
		if (!ScrollTrigger.getById(this.scrollTrigger.id)) {
			this.createScrollTrigger();
		}	
    }
	
    get scrollTrigger() {
		return document.getElementById(this.getAttribute("aria-controls"));
    }

    disconnectedCallback() {
      
    }
	
	_rebuild() {
		if (this.scrollTrigger && ScrollTrigger.getById(this.scrollTrigger.id)) {
			ScrollTrigger.getById(this.scrollTrigger.id).kill(true);
		} else if (ScrollTrigger.getById(this.id)) {
			ScrollTrigger.getById(this.id).kill(true);
		}
		
		this.createScrollTrigger();
		ScrollTrigger.refresh();
	}
	
	createScrollTrigger() {
		
		if (this.scrollTrigger && !this.getAttribute('data-animation')) {
			
			this.scrollTrigger._initialise();
			
			if (!this.scrollTrigger.scrollTriggerConfig.trigger) {
				this.scrollTrigger.scrollTriggerConfig.trigger = this;
			};
			
			// this.scrollTrigger.scrollTriggerConfig.markers = true;
			
			ScrollTrigger.create(
				this.scrollTrigger.scrollTriggerConfig
			);
			
		} else if (this.getAttribute('data-animation')) {
			
			let item = this.firstElementChild,
				timeline = gsap.timeline(),
				positionIn = 0,
				positionOut = 3.5,
			 	animationDuration = 1,
			 	timelineDuration = 25,
				disableTransitionOut,
				animationConfig = JSON.parse(this.getAttribute('data-animation')),
				parallaxMovement = -50;
			
			_createAnimatedElementAnimation(item, timeline, positionIn, positionOut, animationDuration, timelineDuration, disableTransitionOut, animationConfig, parallaxMovement);
						
			var scrollTriggerConfig = {
				animation: timeline,
				trigger: this,
				start: animationConfig['parallaxSpeed'] != 0 ? ((animationConfig['parallaxSpeed'] * parallaxMovement) + "px " + "bottom") : "top bottom",
				end: animationConfig['parallaxSpeed'] != 0 ? ("bottom " + (animationConfig['parallaxSpeed'] * parallaxMovement) + "px") : "bottom top",
				scrub: true,
				anticipatePin: 1,
				id: this.id
			}
			
			// scrollTriggerConfig.markers = true;
			
			ScrollTrigger.create(
				scrollTriggerConfig
			);
		}
	}
};

if (!window.customElements.get("scroll-trigger")) {
	
	let undefinedCustomElements = [],
		customElements = Array.from(document.querySelectorAll(':not(:defined)'));

	customElements.forEach(function(item) {
		if (item.tagName.includes("-") && item.localName != 'scroll-trigger' && item.localName != 'quadpay-widget') {
			undefinedCustomElements.push(item);
		}
	});

	let promises = [...undefinedCustomElements].map((item) => {
		return window.customElements.whenDefined(item.localName);
	});

	Promise.all(promises).then(() => {
		window.customElements.define("scroll-trigger", ScrollTriggerGHD);
	});
}

export {
	ScrollTriggerGHD
}
